import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal, { ModalProps } from '../Modal';

import styles from './QrCodeModal.module.scss';

export type QrCodeModalProps = Omit<ModalProps, 'title' | 'btnClose' | 'close' | 'isVisible'> & {
  url: string;
};

export type OpenQrCodeModalType = QrCodeModalProps & {
  resolve: (value?: any) => void;
  reject: (reason?: any) => void;
};

export type OpenQrCodeModalListenerType = (args: OpenQrCodeModalType) => void;

let listener: OpenQrCodeModalListenerType | null = null;

export type OnCloseQrCodeModalCallbackCallback = () => void;

const setListener = (callback: OpenQrCodeModalListenerType) => {
  listener = callback;
  return removeListener;
};

const removeListener = () => {
  listener = null;
};

export const openQrCodeModal = ({ cssClass, url }: QrCodeModalProps) =>
  new Promise((resolve, reject) => {
    listener && listener({ url, cssClass, resolve, reject });
  });

const QrCodeModal: React.FC = () => {
  const [t] = useTranslation();
  const [arCodeUrl, setArCodeUrl] = useState<string | null>(null);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [closeModal, setCloseModal] = useState<OnCloseQrCodeModalCallbackCallback>(() => {});

  const onUnMount = setListener(async ({ url, resolve }: OpenQrCodeModalType) => {
    setIsVisible(true);
    setArCodeUrl(url);
    const close = () => {
      setIsVisible(false);
      resolve();
    };
    setCloseModal(() => close);
  });

  useEffect(() => {
    return () => {
      onUnMount();
    };
  }, [onUnMount]);

  return (
    <Modal title={t('QR_CODE_MODAL_TITLE')} btnClose={t('X')} isVisible={isVisible} cssClass={styles.ff_qr_code_modal} close={closeModal}>
      <div data-testid='qrcode-modal' className={styles.ff_qr_code_modal__content}>
        {arCodeUrl && <img src={arCodeUrl} alt='qrcode' />}
      </div>
      <div className={styles.ff_qr_code_modal_footer}>
        <span>{t('QR_CODE_MODAL_FOOTER_TEXT')}</span>
      </div>
    </Modal>
  );
};

export default QrCodeModal;
